import { IModuleParams } from './types'
import { isEmptySpaceElement } from './gDriveUtils'
import { createNoteNode } from '../nodeCreationHelpers'
import { PARAGRAPH_SPACING } from '../html_utility'

export function getTeacherBackgroundKnowledge(params: IModuleParams) {
  const docCode = params.metadata.courseCode.split('/').pop() + 'TBK'
  const document = params.gDrive[docCode]
  if (!document) {
    return []
  }
  return parseDocumentContent(document.originalDoc, params)
}

const contentOrder = [
  'What mathematics concepts will students engage with in the unit?',
  'What are some common ideas that students might have?',
  'How do I shorten or condense the unit if needed? How can I extend the unit if needed?',
  'How will I need to modify the unit if taught out of sequence?',
]

type ContentItemType = { title: string; content: string[] }
function parseDocumentContent(document: Document, params: IModuleParams) {
  const addItem = (element: HTMLElement, items: ContentItemType[]) => {
    const lastItem = items.pop()
    if (!lastItem) {
      return items
    }
    lastItem.content.push(element.outerHTML)
    return [...items, lastItem]
  }
  const items = Array.from(document.body.childNodes).reduce<
    { title: string; content: string[] }[]
  >((acc, child) => {
    const element = child as HTMLElement
    switch (element.tagName.toLowerCase()) {
      case 'h3': {
        const title = element.textContent?.trim()
        if (!title) return acc
        acc.push({ title, content: [] })
        return acc
      }
      case 'table':
        if (element.textContent?.startsWith('material-metadata')) {
          return acc
        }
        return addItem(element, acc)
      case 'p':
        if (isEmptySpaceElement(element)) return acc
        return addItem(element, acc)
      default:
        return addItem(element, acc)
    }
  }, [])
  return items
    .filter(({ title }) => contentOrder.includes(title))
    .sort(({ title: t1 }, { title: t2 }) => {
      return contentOrder.indexOf(t1) - contentOrder.indexOf(t2)
    })
    .map(({ title, content }) => {
      return createNoteNode({
        title,
        value: content.join(PARAGRAPH_SPACING),
        studentFacing: false,
      })
    })
}
